module.exports = __webpack_public_path__ + "img/deen2.bbb0138e.jpg";